import axios from 'axios'
import qs from 'qs'
import { getBaseUrl } from '../utils/string-utils'

export class Config { // loads public/config.json
    private serverHost: string = window.location.hostname
    private serverPort: number = Number(window.location.port)

    get isProduction(): boolean {
        return process.env.NODE_ENV === 'production'
    }

    get serverUrl(): string {
        return getBaseUrl('https:', this.serverHost, this.serverPort)
    }

    fillFromProdConfig = async (): Promise<void> => {
        const config: any = await loadConfig('config.json')

        if (config.serverHost) {
            console.debug(`Config: serverHost "${config.serverHost}" set from config`)
            this.serverHost = config.serverHost
        }

        if (config.serverPort) {
            console.debug(`Config: serverPort "${config.serverPort}" set from config`)
            this.serverPort = Number(config.serverPort)
        }
    }

    fillFromUrlParams = (): void => {
        // убираем "?" в начале
        const fixedLocationSearch: string = window.location.search.replace(/^\?/, '')
        const queryParams = qs.parse(fixedLocationSearch) || {}

        if (queryParams.serverHost) {
            console.debug(`Config: serverHost "${queryParams.serverHost}" set from queryParams`)
            this.serverHost = queryParams.serverHost
        }

        if (queryParams.serverPort) {
            console.debug(`Config: serverPort "${queryParams.serverPort}" set from queryParams`)
            this.serverPort = Number(queryParams.serverPort)
        }
    }

    fillFromDevelopConfig = async (): Promise<void> => {
        try {
            const developConfig: any = await loadConfig('develop.config.json')

            if (developConfig.serverHost) {
                console.debug(`Config: serverHost "${developConfig.serverHost}" set from developConfig`)
                this.serverHost = developConfig.serverHost
            }

            if (developConfig.serverPort) {
                console.debug(`Config: serverPort "${developConfig.serverPort}" set from developConfig`)
                this.serverPort = Number(developConfig.serverPort)
            }
        } catch (e) {
            console.error('develop.config.json loading error: ', e)
        }
    }
}

function loadConfig(fileName: string) {
    return axios.get(`${window.location.origin}/${fileName}?${Date.now()}`)
        .then(response => {
            const MIN_OK_STATUS = 200
            const MAX_OK_STATUS = 299

            if (response.status < MIN_OK_STATUS || response.status > MAX_OK_STATUS) {
                let errorMessage = `loading local config failed, status: ${response.status}`
                console.error(errorMessage)
            } else {
                return response.data
            }
        })
}

export const config = new Config()
